import { render, staticRenderFns } from "./RulePanel.vue?vue&type=template&id=5c6028ba&scoped=true&"
import script from "./RulePanel.vue?vue&type=script&lang=js&"
export * from "./RulePanel.vue?vue&type=script&lang=js&"
import style0 from "./RulePanel.vue?vue&type=style&index=0&id=5c6028ba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6028ba",
  null
  
)

export default component.exports